const COLUMNS_TITLE = {
	'1'          : 'Победа хозяев',
	'2'          : 'Победа гостей',
	'1X'         : 'Победа хозяев или ничья',
	'12'         : 'Победа хозяев или гостей',
	'X2'         : 'Победа гостей или ничья',
	'Ф1'         : 'Значение форы хозяев',
	'K1'         : 'Коэффициент форы хозяев',
	'Ф2'         : 'Значение форы гостей',
	'K2'         : 'Коэффициент форы гостей',
	'Т'          : 'Тотал',
	'М'          : 'Меньше',
	'Б'          : 'Больше',
	'Победит'    : 'Победит',
	'Не победит' : 'Не победит'
};
export default COLUMNS_TITLE;


// WEBPACK FOOTER //
// ./src/app/constants/columns_title.js